import { render, staticRenderFns } from "./QuestionTipsDialog.vue?vue&type=template&id=b096024a&scoped=true&"
import script from "./QuestionTipsDialog.vue?vue&type=script&lang=js&"
export * from "./QuestionTipsDialog.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTipsDialog.vue?vue&type=style&index=0&id=b096024a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b096024a",
  null
  
)

export default component.exports